import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../base/use-case";
import { ValidateJobTerminalsAndLocationRequest, ValidateNewJobTerminalsAndLocationRequest } from "../../domain";
import { JobsRepository } from "../../repositories";

@Injectable({ providedIn: 'root' })
export class ValidateNewJobTerminalsAndLocationUsecase implements UseCase<ValidateNewJobTerminalsAndLocationRequest, boolean> {

  constructor(private jobRepository: JobsRepository) {
  }

  execute(params: ValidateNewJobTerminalsAndLocationRequest): Observable<boolean> {
    return this.jobRepository.NewJobTerminalsAndLocationsCheck(params);
  }

}
